import Vue from "vue";
import VueRouter from "vue-router";
import SklibLayoutVue from "@/components/sklib-layout/index.vue";
// import routerBeforeEachApi from "@/api/router-before-each.js";
// import { MessageBox } from "element-ui";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: SklibLayoutVue,
    children: [
      // 首页
      {
        path: "",
        name: "PageHome",
        component: () => import("@/views/page-home/index.vue"),
      },
      // 主题词分析
      {
        path: "subject-word-analysis",
        name: "PageSubjectWordAnalysis",
        component: () => import("@/views/page-subject-word-analysis/index.vue"),
      },
      // 学科趋势分析
      {
        path: "subject-trend-analysis",
        name: "PageSubjectTrendAnalysis",
        component: () =>
          import("@/views/page-subject-trend-analysis/index.vue"),
      },
      // 院校分析
      {
        path: "colleges-and-universities-analysis",
        name: "PageCollegesAndUniversitiesAnalysis",
        component: () =>
          import("@/views/page-colleges-and-universities-analysis/index.vue"),
      },
      // 相关文献
      {
        path: "pertinent-literature",
        name: "PagePertinentLiterature",
        component: () => import("@/views/page-pertinent-literature/index.vue"),
      },
    ],
  },
  { path: "*", redirect: "/" },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

// 查询登录信息接口
// const fetchLoginInfo = async () => {
//   return await routerBeforeEachApi.fetchLoginInfo().catch((error) => {
//     console.error("fetchLoginInfo");
//     throw error;
//   });
// };

// 查询登录信息接口操作
// const handleFetchLoginInfo = async () => {
//   const { branchInfo } = await fetchLoginInfo().catch((error) => {
//     console.error("handleFetchLoginInfo");
//     throw error;
//   });
//   const { isBranchLogin } = branchInfo || {};
//   return Boolean(isBranchLogin);
// };

// router.beforeEach(async (to, from, next) => {
//   const isBranchLogin = await handleFetchLoginInfo().catch((error) => {
//     console.error("beforeEach");
//     console.error(error);
//     next(false);
//     throw error;
//   });
//   if (isBranchLogin) {
//     next();
//     return;
//   }

//   const title = "提示";
//   const message = "您的IP地址不在授权IP范围内，请在授权机构内访问此功能。";
//   const type = "warning";
//   const customClass = "router-before-each__authentication";
//   const showClose = false;
//   const options = { type, customClass, showClose };
//   await MessageBox.alert(message, title, options);
//   location.href = "https://www.sklib.cn/";
//   next(false);
// });

export default router;
